import { Directive, ElementRef, Input, Renderer2, OnChanges } from '@angular/core';

@Directive({
    selector: `[bnComparacaoA]`,
    standalone: false
})
export class BnComparacaoABDirective implements OnChanges {
    @Input() bnComparacaoA: any;
    @Input() bnComparacaoB: any;

    private static SEM_VALOR: string = "sem valor";

    constructor(private element: ElementRef, private renderer: Renderer2) {

    }

    ngOnChanges(changes) {
        if (changes.bnComparacaoA || changes.bnComparacaoB) {
            this.mostraDiferenca(this.temDiferenca());
        }
    }

    private temDiferenca(): boolean {
        return this.bnComparacaoA != this.bnComparacaoB;
    }

    private mostraDiferenca(mostrar: boolean) {
        let divResultado = this.element.nativeElement.parentElement.querySelector('.bn-comparacao-div-resultado');
        let spanResultado, iconeResultado;

        if (divResultado) {
            iconeResultado = divResultado.querySelector('i');
            spanResultado = divResultado.querySelector('span');
        }
        else {
            divResultado = this.renderer.createElement('div');
            this.renderer.setAttribute(divResultado, "class", 'bn-comparacao-div-resultado bn-comparacao-diferente');
            this.renderer.appendChild(this.element.nativeElement.parentElement, divResultado);
            iconeResultado = this.renderer.createElement('i');
            this.renderer.setAttribute(iconeResultado, "class", 'fas fa-not-equal pull-right');
            this.renderer.appendChild(divResultado, iconeResultado);
            spanResultado = this.renderer.createElement('span');
            this.renderer.appendChild(divResultado, spanResultado);
        }


        if (mostrar) {
            this.element.nativeElement.classList.add('bn-comparacao-diferente');
            this.renderer.setStyle(divResultado, 'display', 'block');
            if (this.bnComparacaoB) {
                spanResultado.textContent = this.bnComparacaoB;
            }
            else {
                spanResultado.textContent = BnComparacaoABDirective.SEM_VALOR;
            }
        }
        else {
            this.element.nativeElement.classList.remove('bn-comparacao-diferente');
            this.renderer.setStyle(divResultado, 'display', 'none');
            spanResultado.textContent = "";
        }
    }
}